import React from 'react';
// @ts-ignore
import styles from './DENTToothQuickSelectOptions.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import {
	ToothRestorationCrownType,
	ToothRestorationType,
	ToothSurface,
} from '../../../../graphql/graphql';
import { OverviewMode } from '../../Enums/OverviewMode.enum';

const DENTToothQuickSelectOptions = () => {
	const { handleUpdateToothBulk, setOverviewMode, setAdjustmentMode } =
		useDENTContext();

	const handleOpenCrownModal = () => {
		setOverviewMode(OverviewMode.CROWN);
		setAdjustmentMode(true);
	};

	const handleOpenEndodonticModal = () => {
		setOverviewMode(OverviewMode.ENDODONTIC);
		setAdjustmentMode(true);
	};

	const QUICKSELECT_OPTIONS = [
		{
			title: 'patientTreatment.meddiDENT.dentalCross.overviewModal.extraction',
			onClick: () => handleUpdateToothBulk({ toBeExtracted: true }),
		},
		{
			title: 'patientTreatment.meddiDENT.dentalCross.overviewModal.missing',
			onClick: () => handleUpdateToothBulk({ missing: true }),
		},
		{
			title: 'patientTreatment.meddiDENT.dentalCross.restorationModal.veneer',
			onClick: () =>
				handleUpdateToothBulk({
					restoration: {
						type: ToothRestorationType.Veneer,
						surfaces: [ToothSurface.Buccal],
					},
				}),
		},
		{
			title:
				'patientTreatment.meddiDENT.dentalCross.restorationModal.crownType.pontic',
			onClick: () =>
				handleUpdateToothBulk({
					restoration: {
						type: ToothRestorationType.Crown,
						crownType: ToothRestorationCrownType.Pontic,
						surfaces: [],
					},
				}),
		},
		{
			title: 'patientTreatment.meddiDENT.dentalCross.restorationModal.crown',
			onClick: handleOpenCrownModal,
		},
		{
			title: 'patientTreatment.meddiDENT.dentalCross.endodontic.title',
			onClick: handleOpenEndodonticModal,
		},
	];

	return (
		<div className={styles.wrapper}>
			<div className={styles.buttonsWrapper}>
				{QUICKSELECT_OPTIONS.map(option => (
					<LinkButton
						key={option.title}
						className={styles.button}
						title={option.title}
						theme={Theme.BLUE}
						onClick={option.onClick}
					/>
				))}
			</div>
		</div>
	);
};

export default DENTToothQuickSelectOptions;
